import styled from "styled-components";

export const StyledLinkButton = styled.div`
  position: absolute !important;
  z-index: 10;
  right: 40px;
  top: 12px;
`;
